export default __webpack_public_path__ + "static/nodeOperator@2x-556be91f976e455f536e278ca87f49ad.png";